import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {useParams} from 'react-router-dom';
import {PaginationResponse} from '@common/http/backend-response/pagination-response';
import {Track} from '@app/web-player/tracks/track';
import {Playlist} from '@app/web-player/playlists/playlist';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';

export interface GetPlaylistResponse extends BackendResponse {
  playlist: Playlist;
  tracks: PaginationResponse<Track>;
  totalDuration: number;
  loader: Params['loader'];
}

interface Params {
  loader: 'playlistPage' | 'playlist';
  playlistId?: number;
}

export function usePlaylist(params: Params) {
  const {playlistId: playlistIdFromParams} = useParams();
  const playlistId = params.playlistId ?? playlistIdFromParams;

  return useQuery({
    queryKey: ['playlists', +playlistId!],
    queryFn: () => fetchPlaylist(playlistId!),
    initialData: () => {
      const data = getBootstrapData().loaders?.[params.loader];
      if (data?.playlist?.id == playlistId && data?.loader === params.loader) {
        return data;
      }
      return undefined;
    },
  });
}

function fetchPlaylist(
  playlistId: number | string,
): Promise<GetPlaylistResponse> {
  return apiClient
    .get(`playlists/${playlistId}`)
    .then(response => response.data);
}
